import { apiHttpService } from './apiHttpService';
import { ListResponse, User } from '../domains/app';
import { Group } from '../features/Groups/groups';
import { AxiosResponse } from 'axios';

export const createGroup = (spaceId: string, group: Group): Promise<Group> => {
  return apiHttpService
    .post(
      `/api/Group?spaceId=${spaceId}&groupName=${group.name}&description=${group.description || ''}`,
      {},
    )
    .then((response) => response.data);
};

export const updateGroup = (group: Group): Promise<Group> => {
  return apiHttpService
    .put(
      `/api/Group/${group.id}?newName=${group.name}&description=${group.description || ''}`,
      {},
    )
    .then((response) => response.data);
};

export const deleteGroup = (id: string): Promise<Group> => {
  return apiHttpService
    .delete(`/api/Group/${id}`)
    .then((response) => response.data);
};

export const fetchListGroups = (
  spaceId: string,
  pageSize: number,
  page: number,
  search?: string,
): Promise<ListResponse<Group>> => {
  return apiHttpService
    .get(
      `/api/Group/space/${spaceId}?pageSize=${pageSize}&page=${page}${
        search ? `&searchValue=${search}` : ``
      }`,
    )
    .then((response) => response.data);
};

export const fetchListAllGroups = (
  search?: string,
): Promise<ListResponse<Group>> => {
  return apiHttpService
    .get(
      `/api/Group?pageSize=10000&page=0${
        search ? `&searchValue=${search}` : ``
      }`,
    )
    .then((response: AxiosResponse<ListResponse<Group>>) => {
      response.data.items.forEach((g) => (g.checked = false));
      return response.data;
    });
};

export const addMemberToGroup = (
  id: string,
  personId: string,
): Promise<any> => {
  return apiHttpService
    .post(`/api/Group/${id}/member/${personId}`, {})
    .then((response) => response.data);
};

export const removeMemberFromGroup = (
  id: string,
  personId: string,
): Promise<Group> => {
  return apiHttpService
    .post(`/api/Group/${id}/member/${personId}/remove`, {})
    .then((response) => response.data);
};

export const fetchListMembers = (
  id: string,
  pageSize: number,
  page: number,
): Promise<ListResponse<User>> => {
  return apiHttpService
    .get(`/api/Group/${id}/member?pageSize=${pageSize}&page=${page}`)
    .then((response) => response.data);
};

// eslint-disable-next-line
export default {
  createGroup,
  updateGroup,
  deleteGroup,
  fetchListGroups,
  addMemberToGroup,
  removeMemberFromGroup,
  fetchListMembers,
  fetchListAllGroups,
};
